/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './default-occ-user-account-endpoint.config';
export * from './occ-user-account-endpoint.model';
